import type { AccountSettingsNavItem } from '../../data/saccount_settings.data';
import { ROUTES } from '../../types/global/routes.types';

/** Sidebar, mobile picker, and section heading text. */
export function getAccountSettingsItemLabel(item: Pick<AccountSettingsNavItem, 'name' | 'label'>): string {
    return item.label ?? item.name.charAt(0).toUpperCase() + item.name.slice(1);
}

/** Default account index may render as `/account` or `/account/settings` depending on router config. */
export function isAccountNavItemActive(pathname: string, itemRoute: string): boolean {
    if (pathname === itemRoute) {
        return true;
    }
    if (itemRoute === ROUTES.ACCOUNT_SETTINGS) {
        return pathname === ROUTES.ACCOUNT || pathname === ROUTES.ACCOUNT_SETTINGS;
    }
    return false;
}
